import { render } from "./MessageChannelSelector.vue?vue&type=template&id=b6c7dddc&scoped=true"
import script from "./MessageChannelSelector.vue?vue&type=script&lang=js"
export * from "./MessageChannelSelector.vue?vue&type=script&lang=js"

import "./MessageChannelSelector.vue?vue&type=style&index=0&id=b6c7dddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c7dddc"]])

export default __exports__